import { getCookieCustom } from '../utils/cookies';

type AuthCookieUser = {
 currentlyActiveDb?: string;
 databases?: string[];
};

const slugify = (value: string) =>
 value
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const getCurrentDatabaseSlug = () => {
 const userCookie = getCookieCustom('user');
 if (!userCookie) {
  return '';
 }

 try {
  const user = JSON.parse(userCookie) as AuthCookieUser;
  if (!user.currentlyActiveDb || !Array.isArray(user.databases)) {
   return '';
  }

  const activeDatabase = user.databases.find((databaseItem) =>
   databaseItem.startsWith(`${user.currentlyActiveDb}:`),
  );
  if (!activeDatabase) {
   return '';
  }

  const databaseName = activeDatabase.split(':').slice(1).join(':').trim();
  if (!databaseName) {
   return '';
  }

  return slugify(databaseName);
 } catch {
  return '';
 }
};

const storagePrefix = [import.meta.env.VITE_APP_NAME, getCurrentDatabaseSlug()]
 .filter(Boolean)
 .join('_');

const getConfigStorageItem = (key: string) => {
 const item = localStorage.getItem(`${storagePrefix}_${key}`);
 return item ? JSON.parse(item) : null;
};

const setConfigStorageItem = ({
 page,
 key,
 value,
}: {
 page?: string;
 key: string;
 value: string | object;
}) => {
 const currentValue = getConfigStorageItem(`${page}`);

 localStorage.setItem(
  `${storagePrefix}_${page}`,
  typeof value === 'object'
   ? JSON.stringify({ ...(currentValue ?? {}), [key]: value })
   : value,
 );
};

const removeConfigStorageItem = ({
 page,
 key,
}: {
 page?: string;
 key: string;
}) => {
 const currentValue = getConfigStorageItem(page ? `${page}_${key}` : key);
 const newCurrentValue = Object.keys(currentValue || {}).filter(
  (item) => item !== key,
 );
 localStorage.setItem(
  `${storagePrefix}_${page}`,
  JSON.stringify(newCurrentValue),
 );
};

export { getConfigStorageItem, removeConfigStorageItem, setConfigStorageItem };

